import { render, staticRenderFns } from "./BriqNumberInputWithButtons.vue?vue&type=template&id=0af3609a&scoped=true&lang=pug&"
import script from "./BriqNumberInputWithButtons.vue?vue&type=script&lang=js&"
export * from "./BriqNumberInputWithButtons.vue?vue&type=script&lang=js&"
import style0 from "./BriqNumberInputWithButtons.vue?vue&type=style&index=0&id=0af3609a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3609a",
  null
  
)

export default component.exports